export const initSetupList = [
  {
    title: '公司业务说明',
    desc: '理解业务背景和销售要点',
    isComplete: 0,
    alias: 'companyDescriptionConfig'
  },
  {
    title: '跟进数据管理',
    desc: '要管销售的哪些跟进数据',
    isComplete: 0,
    alias: 'followUpDataManagementConfig'
  },
  {
    title: '跟进助手配置',
    desc: '更准确的输出业务关注点',
    isComplete: 0,
    alias: 'followUpAssistantConfig'
  },
  {
    title: 'AI助理应用权限分配',
    desc: '哪些成员可以使用',
    isComplete: 0,
    alias: 'aiLicenseConfig'
  },
  {
    title: '助手权限分配',
    desc: '分配助手给哪些成员使用',
    isComplete: 0,
    alias: 'assistantPermissionConfig'
  }
]

export const getInitSetupList = (configDetails = []) =>
  initSetupList.map((item) => {
    const configDetail = configDetails.find((detail) => detail.configAlias === item.alias)

    return {
      ...item,
      isComplete: configDetail?.isComplete ?? item.isComplete
    }
  })
